import { hot } from 'react-hot-loader/root';
import { loadable } from '../loadable';
import { mountTarget, unmountTarget } from '../mountable';

// export for use in React
export const LoadableUploadProfilePhotoModal = hot(
  loadable(() => import('./UploadProfilePhotoModal'), {
    key: 'UploadProfilePhotoModal',
    loader: null,
  })
);

// helper function to pop a modal up with a function call
export const showUploadProfilePhotoModal = () => {
  const mount = document.createElement('div');
  const props = {
    onClose: () => {
      unmountTarget(mount);
      document.body.removeChild(mount);
    },
  };

  document.body.appendChild(mount);
  mountTarget(LoadableUploadProfilePhotoModal, mount, props);
};
